import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

const serviceProvidersRouter = {
  path: '/service_providers',
  component: Management,
  redirect: '/service_providers/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/service_providers/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listServiceProviders
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/service_providers/ListTable'),
          meta: {
            auth: Auth.listServiceProviders,
            tabName: 'all'
          }
        }
      ]
    },
    {
      path: 'new',
      component: () => import('@/views/service_providers/New'),
      meta: {
        auth: Auth.createServiceProvider
      }
    },
    {
      path: ':id',
      component: () => import('@/views/service_providers/DetailLayout'),
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/service_providers/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showServiceProvider
          }
        },
        // 共享站
        {
          path: 'ev_charging_stations',
          component: () => import('@/views/service_providers/details/EvChargingStations'),
          meta: {
            tabName: 'ev_charging_stations', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showServiceProvider
          }
        },
        // 订单
        {
          path: 'orders',
          component: () => import('@/views/service_providers/details/Orders'),
          meta: {
            tabName: 'orders', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showServiceProvider
          }
        },
        // 订单统计
        {
          path: 'order_statistics',
          component: () => import('@/views/service_providers/details/OrderStatistics'),
          meta: {
            tabName: 'order_statistics', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showServiceProvider
          }
        },
        // 结算规则
        {
          path: 'settlement_rules',
          component: () => import('@/views/service_providers/details/SettlementRules'),
          meta: {
            tabName: 'settlement_rules', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listSettlementRulesOfServiceProvider
          }
        },
        // 站结算记录
        {
          path: 'ev_charging_station_settlements',
          component: () => import('@/views/service_providers/details/EvChargingStationSettlements'),
          meta: {
            tabName: 'ev_charging_station_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listStationSettlementsOfServiceProvider
          }
        },
        // 结算
        {
          path: 'order_settlements',
          component: () => import('@/views/service_providers/details/OrderSettlements'),
          meta: {
            tabName: 'order_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listOrderSettlementsOfServiceProvider
          }
        },
        // 提现
        {
          path: 'service_provider_withdraw_applications',
          component: () => import('@/views/service_providers/details/ServiceProviderWithdrawApplications'),
          meta: {
            tabName: 'service_provider_withdraw_applications', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listSpWithdrawApplicationsOfServiceProvider
          }
        },
        {
          path: 'transaction_records',
          component: () => import('@/views/service_providers/details/TransactionRecords'),
          meta: {
            tabName: 'transaction_records',
            auth: Auth.listSpTransactionRecordsOfServiceProvider
          }
        },
        {
          path: 'settings',
          component: () => import('@/views/service_providers/details/Settings'),
          meta: {
            tabName: 'settings',
            auth: Auth.showServiceProvider
          }
        }
      ]
    },
    {
      path: ':id/edit',
      component: () => import('@/views/service_providers/Edit'),
      meta: {
        auth: Auth.updateServiceProvider
      }
    }
  ]
}

export default serviceProvidersRouter
